// this file added by Bearer Web Developer
export const validateCode = (value: string) => {
    if (value.length === 0) return "Code is required";
    if (!(value.length === 6) || !value.match(/^[0-9]*$/)) return "Code must be 6 Digits";
    return ''
}